import styled from 'styled-components';

export const SourcesUsesTotalsRowStyled = styled.div`
	display: grid;
	grid-template-columns: 40% 25% 25% 10%;
	background-color: ${({ theme }) => theme.v3.colors.gray[0]};
	flex-shrink: 0;
`;

export const SourcesUsesTotalsRowItemStyled = styled.div<{ visibleRightBorder?: boolean }>`
	min-height: 3rem;
	padding: 0.5rem;
	padding-left: 1rem;
	display: flex;
	flex-direction: column;
	justify-content: center;
	border-right: ${({ visibleRightBorder = false, theme }) =>
		`1px solid ${visibleRightBorder ? theme.v3.colors.gray[4] : theme.v3.colors.gray[0]}`};
`;
